import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-newsletters',
    templateUrl: './newsletters.component.html',
    styleUrls: ['./newsletters.component.scss'],
    standalone: false
})
export class NewslettersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
